import axios from "axios";
import { adminClient } from "./admin";

const publicClient = axios.create({ baseURL: `${process.env.REACT_APP_BACKEND_URL}/api` });

export const REGISTERS = ["A", "B", "C"];
export const FLOAT = 200;
export const DENOMS = [
  { key: "pennies", label: "Pennies", value: 0.01 },
  { key: "nickels", label: "Nickels", value: 0.05 },
  { key: "dimes", label: "Dimes", value: 0.1 },
  { key: "quarters", label: "Quarters", value: 0.25 },
  { key: "ones", label: "$1 bills", value: 1 },
  { key: "fives", label: "$5 bills", value: 5 },
  { key: "tens", label: "$10 bills", value: 10 },
  { key: "twenties", label: "$20 bills", value: 20 },
  { key: "fifties", label: "$50 bills", value: 50 },
  { key: "hundreds", label: "$100 bills", value: 100 },
];
export const SPLIT_FIELDS = [
  { key: "amex", label: "Amex" },
  { key: "mastercard", label: "MasterCard" },
  { key: "visa", label: "Visa" },
  { key: "discover", label: "Discover" },
  { key: "house_account", label: "House Account Sales" },
  { key: "corporate_account", label: "Corporate Account Sales" },
];

export const toCents = (v) => Math.round((Number(v) || 0) * 100);
export const money = (v) => (Number(v) || 0).toLocaleString("en-US", { style: "currency", currency: "USD" });
export const cashCents = (counts) => DENOMS.reduce((s, d) => s + (parseInt(counts?.[d.key], 10) || 0) * Math.round(d.value * 100), 0);

export const kioskSubmitClosing = async (payload) => (await publicClient.post("/kiosk/closing", payload)).data;
export const listClosings = async (params = {}) => (await adminClient().get("/admin/closings", { params })).data.items || [];
export const reconcileClosing = async (id, payload) => (await adminClient().put(`/admin/closings/${id}/reconcile`, payload)).data;
export const editClosingRegisters = async (id, registers) => (await adminClient().put(`/admin/closings/${id}/registers`, { registers })).data;
